<template>
    <div class="mt4">
        <a-row class="mtb8">
            <img class="sbxs mllr4" @click="showAddAction" src="../../../assets/img/ss-add.png" width="25" height="25" >
            <img class="sbxs mllr4" @click="deleteAction" src="../../../assets/img/ss-delete.png" width="25" height="25" >
        </a-row>
        <a-row>
            <vxe-table
                    stripe
                    highlight-hover-row
                    border
                    resizable
                    show-overflow
                    ref="refAction"
                    size="mini"
                    @cell-dblclick=""
                    :data="tableData">
                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                </template>
                <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="module" :title="$t('generic.Module')" minWidth="120"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="orgCode" :title="$t('userlang.Organization')" minWidth="120" v-if="this.proGenericHeaderInfo.geType == 'O'"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="projectCode" :title="$t('generic.Project')" minWidth="120" v-else></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="action" :title="$t('generic.Action')" minWidth="120"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="orderSource" :title="$t('orderSource')" minWidth="200"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="orderType" :title="$t('pubGicSet.OrderType')" minWidth="400"></vxe-table-column>
            </vxe-table>
        </a-row>

        <a-modal
                :title="$t('generic.Add')"
                v-model="addVisible"
                width="50%"
                :maskClosable="maskClosable"
        >
            <template slot="footer">
                <a-button type="primary" @click="saveAction" size="small">{{ $t('publicLang.Save') }}</a-button>
            </template>
            <a-form :form="addForm">
                <a-row>
                    <a-col :span="19">
                        <a-form-item :label="$t('generic.Action')" v-bind="formItemLayout">
                            <a-select
                                    style="width: 100%"
                                    allowClear
                                    size="small"
                                    showSearch
                                    :placeholder="$t('publicLang.PleaseSelect')"
                                    v-decorator="['action',{rules: [{ required: true, message: 'Required', type:'array'}]}]"
                                    @change="filterDataSource"
                                    mode="multiple"
                            >
                                <a-select-option v-for="(item, index) in actionList" :value="item.value" :key="index">{{ item.name }}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="19">
                        <a-form-item :label="$t('orderSource')" v-bind="formItemLayout">
                            <a-select
                                    style="width: 100%"
                                    allowClear
                                    size="small"
                                    showSearch
                                    :placeholder="$t('publicLang.PleaseSelect')"
                                    v-decorator="['orderSource',{rules: [{ required: true, message: 'Required', type:'array'}]}]"
                                    mode="multiple"
                            >
                                <a-select-option v-for="(item, index) in orderSourceList" :value="item.CODE" :key="index">{{ item.CODE_DESC }}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="19">
                        <a-form-item :label="$t('pubGicSet.OrderType')" v-bind="formItemLayout">
                            <a-select
                                    style="width: 100%"
                                    allowClear
                                    size="small"
                                    showSearch
                                    :placeholder="$t('publicLang.PleaseSelect')"
                                    v-decorator="['orderType',{rules: [{ required: true, message: 'Required', type:'array'}]}]"
                                    mode="multiple"
                            >
                                <a-select-option v-for="(item, index) in orderTypeList" :value="item.CODE" :key="index">{{ item.CODE_DESC }}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </a-modal>

    </div>
</template>
<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    export default{
        data(){
            return{
                addVisible:false,
                addForm: this.$form.createForm(this),
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                maskClosable: false,
                actionList:[
                    {name:'Insert',value:'Insert'},
                    {name:'Edit',value:'Edit'},
                    {name:'Cancel',value:'Cancel'},
                    {name:'Delete',value:'Delete'},
                    {name:'Close',value:'Close'},
                ],
                orderSourceList:[],
                orderSourceListTemp:[],
                orderTypeList:[],
                useAsnAction:[
                    'VASN','ASN_HEADER','ASN_DETAIL'
                ],
                useSoAction:[
                    'VSO','SO_HEADER','SO_DETAIL'
                ],
                tableData:[],
                proGenericHeaderInfo:{},
            }
        },
        props: {
            proGenericHeaderProps: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        created(){
            this.initAction(this.proGenericHeaderProps)
        },
        methods:{
            initAction(info){
                this.proGenericHeaderInfo = info
                this.getActionList();
            },
            getActionList(){
                let params = {
                    module: this.proGenericHeaderInfo.subModuleCode,
                    geType: this.proGenericHeaderInfo.geType,
                    orgCode: this.proGenericHeaderInfo.orgCode,
                    projectCode: this.proGenericHeaderInfo.projectCode,
                };
                ajax.get(api.GETGENERICEXTENSIONACTIONLIST,params).then(res => {
                    this.tableData = res.data;
                });
            },
            getOrderTypeOrderSource(){
                let orderType = ""
                if(this.useAsnAction.includes(this.proGenericHeaderInfo.subModuleCode)){
                    orderType = "ASN_ORDERTYPE"
                }else if(this.useSoAction.includes(this.proGenericHeaderInfo.subModuleCode)){
                    orderType = "SO_ORDERTYPE"
                }
                let params = {
                    orderType: orderType
                };
                ajax.get(api.GETORDERTYPEORDERSOURCE,params).then(res => {
                    this.orderSourceList = res.data.orderSourceList;
                    this.orderSourceListTemp = this.orderSourceList
                    this.orderTypeList = res.data.orderTypeList;
                });
            },
            showAddAction(){
                this.addVisible = true
                this.addForm.resetFields();
                this.getOrderTypeOrderSource();
            },
            saveAction(){
                this.addForm.validateFields((err, val) => {
                    if(!err) {
                        let params = {
                            subModuleCode : this.proGenericHeaderInfo.subModuleCode,
                            geType: this.proGenericHeaderInfo.geType,
                            action: val.action.join(','),
                            orderSource: val.orderSource.join(','),
                            orderType: val.orderType.join(','),
                            orgCode: this.proGenericHeaderInfo.orgCode,
                            projectCode: this.proGenericHeaderInfo.projectCode,
                        }
                        ajax.post(api.SAVEGENERICEXTENSIONACTION, params).then(res => {
                            if (res.code === 200) {
                                this.getActionList();
                                this.$message.success(this.$t('cfs.operationSuccess'));
                                this.addVisible = false;
                                this.addForm.resetFields();
                            } else {
                                this.$customMessage.error(res.msg);
                            }
                        });
                    }
                });
            },
            deleteAction(){
                let arr = this.$refs.refAction.getCheckboxRecords()
                if(arr.length == 0){
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
                }else{
                    let that = this;
                    this.$customConfirm({
                        content: this.$t('generic.AreyoudeleTask'),
                        okText: this.$t('publicLang.Confirm'),
                        cancelText: this.$t('publicLang.Cancel'),
                        onOk() {
                            let uids = []
                            for(let i in arr){
                                uids.push(arr[i].uid)
                            }
                            let params = {
                                uids: uids
                            };
                            ajax.post(api.DELETEACTION,params).then(res=>{
                                if(res.code == 200){
                                    that.getActionList();
                                    that.$message.success(res.msg);
                                }else{
                                    that.$customMessage.warning(res.msg);
                                }
                            })
                        },
                        onCancel() {
                            return;
                        }
                    });
                }
            },
            filterDataSource(val){
                if(val != 'Insert'){
                    this.orderSourceList = [{"CODE":"Manual","CODE_DESC":"Manual"}]
                }else {
                    this.orderSourceList = this.orderSourceListTemp
                }
            }
        }
    }
</script>